import { beforeRouteEnterAction } from '@router/router.utils.js'
import SubscriptionsTab from './subpages/subscripitons-tab/route'
import NotesTasksTab from './subpages/notes-tasks-tab/route'
import OrdersInvoicesTab from './subpages/orders-invoices-tab/route'
import ContactsTab from './subpages/contacts-tab/route'
import AddressesTab from './subpages/addresses-tab/route'
import MetaDataTab from './subpages/meta-data-tab/route'

export default {
  path: '/vendors/:id',
  component: () => import(/* webpackChunkName: "vendor-show" */ './VendorShow'),
  props: true,
  meta: {
    requiresAuth: true
  },
  beforeEnter: beforeRouteEnterAction,
  redirect: '/vendors/:id/subscriptions',
  children: [SubscriptionsTab, NotesTasksTab, OrdersInvoicesTab, ContactsTab, AddressesTab, MetaDataTab]
}
